var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6684 4.33203H4.33203V13.6684H13.6684V4.33203Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.668 17.8693L17.8693 13.668H13.668V17.8693Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8693 4.33203H13.668V13.6684H17.8693V4.33203Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6684 13.668H4.33203V17.8693H13.6684V13.668Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.130371 13.668V16.4689C0.130371 17.2426 0.757076 17.8693 1.53083 17.8693H4.33174V13.668H0.130371Z",
    fill: "#188038"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8693 4.33174V1.53083C17.8693 0.757076 17.2426 0.130371 16.4689 0.130371H13.668V4.33174H17.8693Z",
    fill: "#1967D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6681 0.130371H1.53083C0.757076 0.130371 0.130371 0.757076 0.130371 1.53083V13.6681H4.33174V4.33174H13.6681V0.130371Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.2c3101b245bd6fc2999a26aa2e0f1323.svg";
export { ForwardRef as ReactComponent };